import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setConfiguration } from './redux/actions';
import { CreatePostMessage } from './scripts/PostMessage';
import './App.scss';

import Header from './components/Header/Header';
import Information from './components/Screen/Information/Information';
import Settings from './components/Screen/Settings/Settings';
import Buttons from './components/Buttons/Buttons';
import Style from './components/Style'

const App = props => {
  const renderScreen = () => {
    switch(props.currentScreen) {
      case 2:
        return <Settings />
      default:
        return <Information />
    }
  }

  const { setConfiguration } = props;
  useEffect(() => {
    // setConfiguration({});
    CreatePostMessage();
  },[setConfiguration]);

  return (
    <div id="consentui" className={`screen_${props.currentScreen}`}>
      <Header />
      {/* <h1>Hi There</h1> */}
        {renderScreen()}
      <Buttons />
      <Style />
    </div>
  );
  
}

const mapStateToProps = state => {
  return {...state};
}

export default connect(mapStateToProps,{setConfiguration})(App);